if (!window.__tedcoHeroScrollHintInit) {
  window.__tedcoHeroScrollHintInit = true;

  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  const getScrollOffset = () => {
    const cssVar = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height')
    );
    if (!Number.isNaN(cssVar) && cssVar > 0) return cssVar;

    const header = document.querySelector('.section-header');
    return header ? header.offsetHeight : 0;
  };

  const getNextSection = (button) => {
    const currentSection = button.closest('.shopify-section');
    if (!currentSection) return null;

    let nextSection = currentSection.nextElementSibling;
    while (nextSection && !nextSection.classList.contains('shopify-section')) {
      nextSection = nextSection.nextElementSibling;
    }

    return nextSection;
  };

  const animateScrollTo = (targetY, duration = 900) => {
    const start = window.scrollY;
    const distance = targetY - start;
    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      window.scrollTo(0, start + distance * easeOutCubic(progress));
      if (progress < 1) window.requestAnimationFrame(step);
    };

    window.requestAnimationFrame(step);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hero-scroll-hint]');
    if (!button) return;

    event.preventDefault();

    const nextSection = getNextSection(button);
    if (!nextSection) return;

    const targetY = nextSection.getBoundingClientRect().top + window.scrollY - getScrollOffset();
    animateScrollTo(targetY);
  });
}
